<template>
  <div>
    <van-nav-bar
      left-arrow
      left-text="返回"
      title="我的二级分销团队"
      @click-left="$router.back()"
    />
    <div style="text-align: center;padding: 16px">我的分销团队人数：{{ datas.length ? datas.length : 0 }}</div>
    <div style="box-sizing: border-box;width: 100vw;padding: 16px">
      <div v-if="datas.length">
        <div v-for="(item,id) in datas" :key="id">
          <div class="user-info" style="margin-top: 16px">
            <span class="phone">{{ item.name }} </span>
            <span style="width: 16px"/>
            <span class="name">(尾号{{ item.phone.slice(-4) }})</span>
          </div>
          <div class="name" style="font-size: 12px;color: #686868">注册时间：{{
              DateUtils.formate(item.createTime, 'yyyy-MM-DD HH:mm:ss')
            }}
          </div>
          <div style="width: 100%;height: 1px;background-color: #c6c6c6;margin-top: 8px"></div>

        </div>
      </div>
      <div v-else>
        <div style="text-align: center;margin-top: 16px">
          <div style="font-size: 14px;color: #686868">暂无成功邀请的人员</div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

import DistributionDao from '@/h5/doucan/pages/distribution/DistributionDao'
import DateUtils from '../../../../utils/DateUtils'

export default {
  name: 'DistributionMySecondListPage',
  computed: {
    DateUtils () {
      return DateUtils
    }
  },
  data () {
    return {
      datas: null,
      user: null
    }
  },
  created () {
    this.user = this.$store.state.distributor.data
    console.log('user', this.user)
    this.load()
  },
  methods: {

    load () {
      console.log('onDetailClick')
      DistributionDao.loadMySecondDistributors(this.user.id).then(res => {
        console.log('loadDetails', res)
        this.datas = res
      })
    }

  }
}
</script>

<style scoped>
.user-info {
  display: flex;
  align-items: center;
}

.name {
  margin-right: auto; /* 将姓名推到左侧 */
}

.phone {
  /* 可以添加其他样式，比如颜色、字体大小等 */
}

.btn {
  width: 100%;
  height: 48px;
  line-height: 48px;
  margin-bottom: 8px;
  border-radius: 8px;
  text-align: center;
  background-color: #007373;
  color: white;
}
</style>
